import Plyr from 'plyr'
import '@/node_modules/plyr/dist/plyr.css'
import videoTranslations from '@/js/misc/plyr-translation.js'

const VideoElements = document.querySelectorAll('.Video-video')

const VideoCaptionButtons = document.querySelectorAll(
  '.Video-mediaCaptionButton',
)

if (VideoCaptionButtons) {
  Array.prototype.forEach.call(
    VideoCaptionButtons,
    function (captionButtonElement) {
      captionButtonElement.addEventListener('click', () => {
        const itemElement = document.querySelector(
          '#' + captionButtonElement.getAttribute('aria-controls'),
        )

        if (
          !captionButtonElement.getAttribute('aria-expanded') ||
          captionButtonElement.getAttribute('aria-expanded') == 'false'
        ) {
          captionButtonElement.setAttribute('aria-expanded', true)
          itemElement.classList.add('Video--captionExpanded')
        } else {
          captionButtonElement.setAttribute('aria-expanded', false)
          itemElement.classList.remove('Video--captionExpanded')
        }
      })
    },
  )
}

const userPrefersReducedMotion =
  window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
  window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true

document.addEventListener('DOMContentLoaded', () => {
  Array.prototype.forEach.call(VideoElements, function (videoElement) {
    const source = videoElement.querySelector('source')

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          source.src = source.dataset.src
          videoElement.load()
          const currentAspectRatio = videoElement.getAttribute(
            'data-aspect-ratio-js',
          )

          const videoPlayer = new Plyr(videoElement, {
            controls: ['play'],
            i18n: videoTranslations,
            resetOnEnd: true,
            language: 'de',
            ratio: currentAspectRatio,
            autoplay: !userPrefersReducedMotion,
            hideControls: false,
          })

          videoPlayer.on('canplay', (event) => {
            event.detail.plyr.media.classList.remove('Video-video--loading')
          })

          observer.unobserve(videoElement)
        }
      })
    })

    observer.observe(videoElement)
  })
})
